import { DropdownDisplayItem } from '../dropdown-display-item';
import { UnitValue } from '../unit-value.model';

export interface FeedstockMaterialInterface {
  id: string;
  category: string;
  type: string;
  source: string;
  isAnimal: boolean;
  catTranslationId: string;
  typeTranslationId: string;
  sourceTranslationId: string;
  totalSolids: UnitValue;
  volatileSolids: UnitValue;
  biochemMethanePot: UnitValue;
  methaneConcentration: UnitValue;
}

export class FeedstockMaterial {
  id: string;
  category: string;
  type: string;
  source: string;
  isAnimal: boolean;
  catTranslationId: string;
  typeTranslationId: string;
  sourceTranslationId: string;
  totalSolids: UnitValue;
  volatileSolids: UnitValue;
  biochemMethanePot: UnitValue;
  methaneConcentration: UnitValue;

  constructor(param: FeedstockMaterialInterface = {
    id: null,
    category: null,
    type: null,
    source: null,
    isAnimal: false,
    catTranslationId: null,
    typeTranslationId: null,
    sourceTranslationId: null,
    totalSolids: null,
    volatileSolids: null,
    biochemMethanePot: null,
    methaneConcentration: null,
  }) {
    this.id = param.id;
    this.category = param.category;
    this.type = param.type;
    this.source = param.source;
    this.isAnimal = param.isAnimal;
    this.catTranslationId = param.catTranslationId;
    this.typeTranslationId = param.typeTranslationId;
    this.sourceTranslationId = param.sourceTranslationId;
    this.totalSolids = param.totalSolids;
    this.volatileSolids = param.volatileSolids;
    this.biochemMethanePot = param.biochemMethanePot;
    this.methaneConcentration = param.methaneConcentration;
  }

  static getUnknownDisplayItem() {
    return new DropdownDisplayItem('PROJECT.FEEDSTOCK.TYPE.UNKNOWN', 'unknown');
  }

  static getUnknownDisplayMaterial() {
    const unknownMaterial: FeedstockMaterialInterface = {
      id: null,
      category: 'unknown',
      type: 'unknown',
      source: 'unknown',
      isAnimal: true,
      catTranslationId: 'PROJECT.FEEDSTOCK.TYPE.UNKNOWN',
      typeTranslationId: 'PROJECT.FEEDSTOCK.TYPE.UNKNOWN',
      sourceTranslationId: 'PROJECT.FEEDSTOCK.TYPE.UNKNOWN',
      totalSolids: null,
      volatileSolids: null,
      biochemMethanePot: null,
      methaneConcentration: null,
    };
    return new FeedstockMaterial(unknownMaterial);
  }
}


